<template>
    <div class="department" :style="mainContentViewHeight"
         v-loading="loading"
         element-loading-text="拼命加载中">
        <div class="department-box" :style="mainContentViewHeight">
            <ul class="aside" style="width:442px; padding:20px 0 0 10px;" :style="leftContentViewHeight">
                <li class="down"> 
                    <el-tabs  v-model="currentRoleType"    @tab-click="chooseRoleType" >
                        <el-tab-pane label="所有" key="0" name="0"> </el-tab-pane>
                        <el-tab-pane label="交易中心" key="1" name="1"> </el-tab-pane>
                        <el-tab-pane label="法人" key="2" name="2"> </el-tab-pane>
                        <el-tab-pane label="自然人" key="3" name="3"> </el-tab-pane>
                    </el-tabs>
                    <el-form :inline="true" :model="dataForm" @keyup.enter.native="getCategoryTRee()">
                        <el-form-item style="width:60%;">
                            <el-input v-model="dataForm.searchKey" placeholder="请输入关键字" clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button @click="getCategoryTRee()">查询</el-button>
                        </el-form-item>
                    </el-form>                    
                    <el-button v-if="selectAllCa" type="primary"  @click="loadAllCaInfo()" style="width:100%">所有已经绑定CA账号</el-button>
                    <el-button v-else  @click="loadAllCaInfo()" style="width:100%">所有已经绑定CA账号</el-button>
                    <el-table @row-click="chooseCorpRow" 
                                    :show-header="false" v-if="currentRoleType==2" highlight-current-row :data="dataList" border style="width: 100%">                        
                            <el-table-column
                                    prop="orgName"
                                    header-align="left"
                                    align="left"
                                    label="企业名称">
                            </el-table-column>
                    </el-table>                
                    <el-table @row-click="dangqianhang"
                                :show-header="false" v-else highlight-current-row :data="dataList" border style="width: 100%">
                        <el-table-column 
                                     prop="userName" header-align="left" align="left" label="用户名"></el-table-column>
                    </el-table>
                    <div class="pageDiv">
                         <el-pagination
                                 small
                                 @size-change="sizeChangeHandle"
                                 @current-change="currentChangeHandle"
                                 :current-page="pageIndex"
                                 :page-size="pageSize"
                                 :total="totalPage"
                                 layout="prev, pager, next">
                         </el-pagination>
                    </div>
                </li>
            </ul>
            <el-card class="box-card main" style="padding-top: 10px;" :style="leftContentViewHeight">
                <div slot="header" class="clearfix">
                    <span>CA认证管理-{{subTile}}</span>
                    <p class="buttonAdd">
                         <el-button type="primary" v-if="!selectAllCa" icon="el-icon-plus" v-debounce="[showAddDialog,'click',500]">添加CA锁</el-button>
                         <el-button type="primary" icon="el-icon-document-delete" v-debounce="[delCA,'click',500]">解綁CA</el-button>
                         <el-button type="primary" v-debounce="[selectNode,'click',500,1]" icon="el-icon-refresh">刷新</el-button>
                    </p>
                </div>
                <el-form :inline="true" :model="caDataForm" @keyup.enter.native="selectNode()">
                <el-form-item>
                    <el-input v-model="caDataForm.searchKey" placeholder="请输入关键字" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="selectNode()">查询</el-button>
                </el-form-item>
                </el-form>
                <el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange" >
                    <el-table-column label="序号"  width="55" type="index" align="left"></el-table-column>
                    <el-table-column type="selection" align="left"></el-table-column>
                    <el-table-column label="操作" width="100"  align="center">
                        <template slot-scope="scope">
                            <i class="el-icon-view" @click="updatePass(scope.row)"></i>
                        </template>
                    </el-table-column>
                    <el-table-column label="CA锁ID" align="left" prop="caCode"></el-table-column>
                    <el-table-column label="状态"  width="100" align="center" prop="status">
                        <template slot-scope="scope">{{ scope.row.status==1?'启用':'禁用'}}</template>
                    </el-table-column>
                    <el-table-column label="CA显示名称" align="left" prop="friendlyName"></el-table-column>
                    <el-table-column label="到期时间" align="left" prop="expireDate"></el-table-column>
                    <el-table-column label="备注" align="left" prop="remark"></el-table-column>
                </el-table>
                 <el-pagination
                    @size-change="sizeChangeHandle1"
                    @current-change="currentChangeHandle1"
                    :current-page="pageIndex1"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize1"
                    :total="totalPage1"
                    layout="total, sizes, prev, pager, next, jumper">
                 </el-pagination>
            </el-card>
        </div>
        <el-dialog title="详情" :visible.sync="dialogVisibleMes" width="40%">
            <div>
                <el-form ref="form" :model="formData" label-width="150px" class="form">
                    <el-form-item label="CA显示名称:" style="width:49%;" prop="password">
                          <span>{{formData.friendlyName}}</span>
                    </el-form-item>
                    <el-form-item label="有效开始时间:" style="width:49%;" prop="password">
                          <span>{{formData.fromDate}}</span>
                    </el-form-item>
                    <el-form-item label="有效截止时间:" style="width:49%;" prop="password">
                          <span>{{formData.expireDate}}</span>
                    </el-form-item>
                    <el-form-item label="状态:" style="width:49%;" prop="password">
                          <span>{{formData.status}}</span>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleMes = false" class="backBtn">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    import {initCa, getCaInfo, SignData} from '@/plugins/pmca'
    import {tabsRefreshCurrentHandle} from '@/utils/routeTab.js'
    export default {
        props: ['mainContentViewHeight','orgInfo'],
        name: "department",
        data() {
            return {
                dialogVisible:false,
                dialogVisibleMes:false,
                tableData:[],
                dataList: [],
                certPwd: true,
                subTile:'已绑定CA列表',
                selectAllCa:true,
                currentRoleType: '0',
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,

                pageIndex1: 1,
                pageSize1: 10,
                totalPage1: 0,
                loading: true,
                form:{
                    val:'',
                    password:''
                },
                formData:{

                },
                caDataForm:{                    
                    searchKey: ''
                },
                CAInfo:{
                    id:'',
                    corpId:'',
                    tradeOrgId:'',
                    caCode:'',
                    expireDate:'',
                    friendlyName:'',
                    fromDate:'',
                    remark:'',
                    userId:'',
                },
                dataForm: {
                    searchKey: ''
                },
                deleteCA:[],
            }
        },

        created() {
            this.getCategoryTRee();
            this.selectNode();
        },
        //  activated() {
        //     this.getCategoryTRee();
        //     this.selectNode();
        // },
        computed: {
            hasItemId: {
                get() {
                    return this.itemid != '' && this.itemid != undefined
                }
            },
            leftContentViewHeight: {
                get() {
                    return {height: this.mainContentViewHeight.minHeight}
                }
            },
        },
        methods: {
            loadAllCaInfo(){
                this.selectAllCa=true
                this.caDataForm.searchKey=''
                this.subTile='已绑定CA列表'
                this.CAInfo.userId=''
                this.CAInfo.corpId=''
                this.getCategoryTRee();
                this.selectNode(1)
            },
            chooseRoleType(){ 
                this.getCategoryTRee();
            },
            showAddDialog(){
                var that = this;
                if(this.currentRoleType==='2'){
                    if (this.CAInfo.corpId === '' || this.CAInfo.corpId === undefined){
                        this.$alert('请先点击左侧列表选择用户', '提示', {
                            confirmButtonText: '确定',
                        });
                        return
                    }
                }
                else if (this.CAInfo.userId === '' || this.CAInfo.userId === undefined){
                    this.$alert('请先点击左侧列表选择用户', '提示', {
                        confirmButtonText: '确定',
                    });
                    return
                }
                initCa((isIE) => {
                    if (!isIE) {
                        this.$alert(
                            "请使用ie10及以上浏览器",
                            "提示",
                            {confirmButtonText: "确定"}
                        );
                    }
                })
                try { 
                    getCaInfo((certInfo) => {
                        this.CAInfo.caCode = certInfo.certserial
                        this.CAInfo.friendlyName = certInfo.subject_cn
                        this.CAInfo.expireDate = certInfo.validendtime
                        this.CAInfo.fromDate = certInfo.validstarttime
                        this.CAInfo.remark = certInfo.certName
                        this.updateSave()
                    })
                } catch (error) {
                    console.log(error)
                    this.$alert(
                            "请检查CA驱动是否安装成功！",
                            "提示",
                            {confirmButtonText: "确定"}
                        );
                }
            },
            updateSave(){ //添加CA锁
                this.$http.post('/sys/syscainfo/save',this.CAInfo).then(({data}) => {
                    if (data && data.code === '1') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                // this.tabsCloseCurrent()
                                this.selectNode()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                    this.dialogVisible = false
                })
            },
            updatePass(row){ //详情
                const id = row.id
                this.dialogVisibleMes = true
                this.$http.get('/sys/syscainfo/get?id='+id).then(({data}) => {
                    this.formData = data.data
                })
            },
            getCategoryTRee() { //用户列表
                this.loading=true
                let url         
                if(this.currentRoleType==='2'){
                    url='/basic/sysorganization/list'
                }
                else if(this.currentRoleType==='3'){
                    url='/auth/naturaluser/searchlist'
                }
                else if(this.currentRoleType==='1'){
                    url='auth/employee/searchlist'
                }else{
                    url='/auth/sysuser/search_user_list'
                }
                this.$http.post(url, {
                    'page': this.pageIndex,
                    'rows': this.pageSize,
                    'searchKey': this.dataForm.searchKey,
                }).then(({data}) => {
                    if (data) {
                        this.dataList = data.rows
                        this.totalPage = data.totalItemCount
                    } else {
                        this.dataList = []
                        this.totalPage = 0
                    }
                    this.loading=false
                })
            },
            selectNode(status) { //CA认证管理
                if(status == 1){
                    this.CAInfo.userId = '';
                }
                if(this.CAInfo.corpId==undefined){
                    this.CAInfo.corpId=''
                }
                if(this.CAInfo.userId==undefined){
                    this.CAInfo.userId=''
                }
                this.loading = true;
                this.$http.post('/sys/syscainfo/list', {
                    'filter':{
                        'orgId': this.CAInfo.corpId,
                        'userId' : this.CAInfo.userId
                    },
                    'searchKey': this.caDataForm.searchKey,
                    'page': this.pageIndex1,
                    'rows': this.pageSize1,
                }).then(({data}) => {
                    if (data) {
                        this.tableData = data.rows;
                        this.totalPage1 = data.totalItemCount;
                    } else {
                        this.tableData = [];
                        this.totalPage1 = 0;
                    }
                    this.loading = false;
                })
            },
            handleSelectionChange(val){ //CA认证管理表格复选框事件
                this.deleteCA = val;
            },
            delCA(){ //解綁CA事件
                if(this.deleteCA.length > 0){
                    let commitArr = [];
                    this.deleteCA.forEach((item,index)=>{
                        commitArr.push(item.id)
                    })
                    console.log(commitArr.join(','))
                    this.$http.delete('/sys/syscainfo/delete',{
                        params:{
                            'ids' : commitArr.join(',')
                        }
                    }).then(res=> {
                        if (res.data.code == 1) {
                            this.$message.success(res.data.msg);
                            this.selectNode();
                        } else {
                            this.$message.success(res.data.msg)
                        }
                    })
                }else{
                    this.$message.error('请至少勾选一条数据');
                }
            },
            dangqianhang(row){ 
                this.caDataForm.searchKey=''
                this.selectAllCa=false
                this.subTile=row.userName
                this.CAInfo.userId = row.id;
                this.selectNode();
            },
            chooseCorpRow(row){  
                this.caDataForm.searchKey=''
                this.selectAllCa=false
                this.subTile=row.orgName
                this.CAInfo.corpId = row.id;
                this.selectNode();
            },
            sizeChangeHandle(val) {
                this.pageSize = val
                this.pageIndex = 1
                this.getCategoryTRee();
            },
            currentChangeHandle(val) {
                this.pageIndex = val
                this.getCategoryTRee();
            },
            sizeChangeHandle1(val) {
                this.pageSize1 = val
                this.pageIndex1 = 1
                this.selectNode();
            },
            currentChangeHandle1(val) {
                this.pageIndex1 = val
                this.selectNode();
            },
        }
    }
</script>

<style lang="scss" scoped>
    .department {
        position: relative;
        .department-box {
            display: flex;
            .aside, .main {
            background-color: #fff;
        }
            .buttonAdd{
                position: absolute;
                top: 10px;
                right: 30px;
            }
        }
    }
    .pageDiv{
        position: absolute;
        bottom: 20px;
        left: 0;
    }
</style>
